@for (filterSummary of filtersSummary; track $index) {
  <mat-icon
    class="collapsed-filter material-icons-outlined"
    [class]="{
      'collapsed-filter--active': filterSummary.isActive,
      'collapsed-filter--hidden': filterSummary.hidden,
    }"
    [matTooltip]="filterSummary.title"
    matTooltipPosition="right"
    [mpIcon]="filterSummary.icon"
  />
}
